<div class="bylaws-preview">

  <div *ngIf="errors.length" class="alert alert-warning mb-3">
    <div class="fw-semibold mb-2">Fix these fields before you finish:</div>
    <ul class="mb-0 small">
      <li *ngFor="let error of errors">{{ error }}</li>
    </ul>
  </div>

  <div *ngIf="html; else emptyState">
    <div [innerHTML]="html | safeHtml"></div>
  </div>

  <ng-template #emptyState>
    <div class="border rounded-3 bg-light p-3 text-muted">
      <p class="mb-1" *ngIf="loading">Rendering bylaws preview…</p>
      <p class="mb-0" *ngIf="!loading">Complete the wizard to render your bylaws.</p>
    </div>
  </ng-template>

</div>
